import React from 'react';
import { getLayoutProps, getVacancyContent } from '@app/utils/serverSidePropsUtils';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ApiResponse, VacancyDto } from '@app/models/dtos/strapi';
import Layout from '@app/layouts/_layout';
import { BreadcrumbsItem } from '@app/models/props/breadcrumbs-item';
import { useRouter } from 'next/router';
import BreadcrumbRenderer from '@app/components/renderer/breadcrumbs-renderer';
import Button from '@app/components/ui/button';
import AboutVacancy from '@app/components/career/about';
import VacancyExpectation from '@app/components/career/expectation';
import VacancyResponsibility from '@app/components/career/resposibility';
import RadialGradient from '@app/components/ui/radial-gradient';
import { ILayoutProps } from '@app/models/props/home';

export async function getServerSideProps({ locale, query }: any) {
    const vacancy = await getVacancyContent({ position: query['position'] });
    const layoutProps = await getLayoutProps();
    if (!vacancy) {
        return {
            notFound: true
        };
    }
    return {
        props: {
            vacancy,
            ...layoutProps,
            ...(await serverSideTranslations(locale, ['common'], null, ['en', 'nl']))
        }
    };
}

export interface IVacancyProps extends ILayoutProps {
    vacancy: VacancyDto;
}

function Vacancy({ vacancy, settings, locations, products, socialMedias }: IVacancyProps) {
    const router = useRouter();
    const locale = router?.locale === 'en' ? '' : `${router?.locale}/`;
    const breadcrumbsItem: Array<BreadcrumbsItem> = [
        {
            title: 'Career',
            url: `/${locale}career`
        },
        {
            title: `${vacancy.position}`,
            disabled: true
        }
    ];

    const handleApply = () => {
        vacancy.formUrl ? window.open(vacancy.formUrl) : null;
    };
    return (
        <Layout childClassName="flex flex-col items-center w-full" locations={locations} products={products} settings={settings} socialMedias={socialMedias}>
            <RadialGradient />
            <div className="container flex w-full flex-col items-start">
                <BreadcrumbRenderer items={breadcrumbsItem} />
                <div className="mb-[40px] mt-[50px] md:mb-[80px] md:mt-[110px]">
                    <p className="P2 !text-black-1">Join Us</p>
                    <p className="h2-responsive my-6 text-black-1">{vacancy.position}</p>
                    <p className="P1 mb-10 max-w-[384px]">{vacancy.description}</p>
                    <Button size="large" onClick={handleApply}>
                        Apply Now
                    </Button>
                </div>
            </div>
            {vacancy.about && <AboutVacancy about={vacancy.about} />}
            {(vacancy.expect || vacancy.responsibilities) && (
                <div className="container my-[60px] flex w-full flex-col items-center md:my-[160px]">
                    <div className="flex max-w-[640px] flex-col gap-[50px] px-5 md:gap-[127px]">
                        {vacancy.expect && <VacancyExpectation expect={vacancy.expect} />}

                        {vacancy.responsibilities && vacancy.responsibilities.length !== 0 && <VacancyResponsibility responsibilities={vacancy.responsibilities} handleApply={handleApply} />}
                    </div>
                </div>
            )}
        </Layout>
    );
}

export default Vacancy;
